// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '../../../../store/session';
import ActivateDeactivate from './actions/ActivateDeactivate';
// Components
import Dropdown from '../../../../../common-utils/components/renders/dropdown/Dropdown';
import ModalUpdateLabel from '../modals/ModalUpdateLabel';
// Common
import Permissions from '../../../../permissions/Permissions';
import ICONS from '../../../../../common-utils/enums/icons';
import merchantAccountFields from '../../fields/merchantAccountFields';
// Lang
import { nsAccount } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 * @param root0
 * @param root0.merchantAccount
 * @param root0.setLaunchRefetch
 * @returns {JSX} DropdownMerchantAccountActionsRow
 */
function DropdownMerchantAccountActionsRow({ merchantAccount, setLaunchRefetch }) {
    //Constants
    const merchantAccountId = merchantAccount ? merchantAccount[merchantAccountFields.UUID.key] : null;
    const merchantAccountLabel = merchantAccount ? merchantAccount[merchantAccountFields.LABEL.key] : null;
    // Store
    const session = useSessionStore(s => s.session);
    const permissions = session.permissions;
    //State
    const [showModalUpdateLabel, setShowModalUpdateLabel] = useState(false);
    //Functions
    const handleShowModalUpdateLabel = () => {
        setShowModalUpdateLabel(true);
    };
    return (
        <>
            <Dropdown
                dataCy='merchant-account-actions-dropdown-row'
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    ...ActivateDeactivate(merchantAccount, permissions, setLaunchRefetch),
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.update_label',
                        namespace: nsAccount,
                        onClick: handleShowModalUpdateLabel,
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [
                                Permissions.CONTRACTS_ACCESS_UPDATE.name
                            ]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]} />
            {
                showModalUpdateLabel &&
                <ModalUpdateLabel
                    isOpen={showModalUpdateLabel}
                    setIsOpen={setShowModalUpdateLabel}
                    merchantAccountId={merchantAccountId}
                    merchantAccountLabel={merchantAccountLabel}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
        </>
    );
}

DropdownMerchantAccountActionsRow.propTypes = {
    merchantAccount: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};
export default DropdownMerchantAccountActionsRow;